import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTenant } from "../tenant/TenantContext";
import {
  hostsGlobalAccountInBrandManager,
  toBrandManagerGlobalPath,
} from "../brandManagerPaths";

/**
 * Client tenants: legacy /master-account/account* → Brand Manager Account.
 * User Management stays in the Brand shell (and also exists globally in BM).
 * Vendors: leave Account children in the Master shell.
 */
export default function LegacyClientGlobalRedirect({ children }) {
  const location = useLocation();
  const { tenant } = useTenant();
  const kind = tenant?.kind || "client";

  if (hostsGlobalAccountInBrandManager(kind)) {
    const target = toBrandManagerGlobalPath(location.pathname);
    if (target) {
      return (
        <Navigate
          to={`${target}${location.search || ""}${location.hash || ""}`}
          replace
        />
      );
    }
  }

  return children;
}
